

































































































import Vue from 'vue';

const cookieVersion = '1';

interface Data {
  cookiesAccepted: boolean;
}

export default Vue.extend({
  name: 'site-footer',
  data: (): Data => {
    const acceptedVersion = localStorage.getItem('cookiesAccepted');
    if (acceptedVersion) {
      if (acceptedVersion === cookieVersion) {
        return { cookiesAccepted: true };
      }
    }
    return { cookiesAccepted: false };
  },
  methods: {
    clickAccept() {
      localStorage.setItem('cookiesAccepted', cookieVersion.toString());
      this.cookiesAccepted = true;
    },
  },
});
